module.exports = __webpack_public_path__ + "img/r2.a052697c.jpg";